export default __webpack_public_path__ + "static/media/frog-lit.60f72545.jpeg";